import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Telas",
    items: [
      { label: "Colores",            icon: "fas fa-palette",     href: "/Colores",                     perm: "menu_colores"     },
      { label: "Tipo de Tela",       icon: "fab fa-staylinked",  href: "/TiposTelas",                  perm: "menu_tipos_telas" },
      { label: "Telas",              icon: "fas fa-tape",        href: "/ListadoTelas",                perm: "menu_telas"       },
      // Tela por cantidad (sin rollos ni QR): la existencia real es la del inventario por almacen.
      { label: "Inventario Telas",   icon: "fas fa-warehouse",   href: "/ExistenciasMateriales?tipo=Telas", perm: "menu_telas"  },
      { label: "Seguimiento Telas",  icon: "fas fa-search",      href: "/ListadoSeguimientoTelas",     perm: "menu_telas"       },
      { label: "Salida de Material", icon: "fas fa-sign-out-alt", href: "/ListadoSalidaTelas",         perm: "menu_telas"       },
    ],
  },
  {
    title: "Habilitación",
    items: [
      { label: "Habilitación",            icon: "fas fa-tag",    href: "/ListadoHabilitacion",            perm: "menu_habilitacion" },
      { label: "Inventario Habilitación", icon: "fas fa-tags",   href: "/ExistenciasMateriales?tipo=Habilitacion", perm: "menu_habilitacion" },
      { label: "Requisición vs Salida",   icon: "fas fa-tasks",  href: "/ReporteSalidaHabilitacion",      perm: "menu_habilitacion" },
      { label: "Requisición de Pedidos",  icon: "fas fa-clipboard-list", href: "/ReporteRequisicion",  perm: "menu_habilitacion" },
      { label: "Seguimiento Habilitación", icon: "fas fa-search", href: "/ListadoSeguimientoHabilitacion", perm: "menu_habilitacion" },
    ],
  },
  {
    title: "Artículos",
    items: [
      { label: "Marcas",            icon: "far fa-copyright",       href: "/Marcas",                 perm: "menu_articulos" },
      { label: "Colecciones",       icon: "fas fa-calendar-alt",    href: "/Colecciones",            perm: "menu_articulos" },
      { label: "Departamentos",     icon: "fas fa-list-ul",         href: "/ListadoDepartamentos",   perm: "menu_articulos" },
      { label: "Sub Departamentos", icon: "fas fa-list-ul",         href: "/ListadoSubDepartamentos", perm: "menu_articulos" },
      { label: "Clases",            icon: "fas fa-bars",            href: "/ListadoClases",          perm: "menu_articulos" },
      { label: "Etiquetas",         icon: "fas fa-bars",            href: "/ListadoSubClases",       perm: "menu_articulos" },
      { label: "Tallas",            icon: "fas fa-ruler-horizontal", href: "/ListadoTallas",         perm: "menu_articulos" },
      { label: "Artículos",         icon: "fas fa-tshirt",          href: "/ListadoArticulos",       perm: "menu_articulos" },
    ],
  },
  {
    title: "Clientes",
    items: [
      { label: "Clientes",    icon: "fas fa-user-tie",       href: "/Clientes",           perm: "menu_clientes" },
      { label: "Compradores", icon: "fas fa-user-tie",       href: "/ListadoCompradores", perm: "menu_clientes" },
    ],
  },
  {
    title: "Proveedores",
    items: [
      { label: "Proveedores", icon: "fas fa-dolly", href: "/Proveedores", perm: "menu_proveedores" },
    ],
  },
  {
    title: "Producción",
    items: [
      { label: "Maquileros",        icon: "fas fa-dolly", href: "/Maquileros",       perm: "menu_proveedores" },
    ],
  },
  {
    title: "Material en almacenes",
    items: [
      { label: "Existencias de Material", icon: "fas fa-warehouse",     href: "/ExistenciasMateriales",     perm: "menu_telas" },
      { label: "Traspasos de Material",   icon: "fas fa-exchange-alt",  href: "/ListadoTraspasosMateriales", perm: "menu_telas" },
    ],
  },
];

function BotonesMateriales() {
  return (
    <MenuGrid
      title="Catálogos"
      subtitle="Telas, habilitación, artículos, clientes y proveedores"
      icon="fas fa-box"
      accent={{ color: "#10b981", bg: "#f0fdf4" }}
      gate="menu_articulos"
      sections={SECTIONS}
    />
  );
}

export default BotonesMateriales;
